export function getUniversalItem(extraFields: IItemToSelect = {}): IItemToSelect {
  return {
    felItemTypeId: -1,
    ...extraFields,
    id: 1,
    value: 1,
    code: 'UNIX',
    label: 'Universal',
    name: 'Universal',
    list: [],
    line: [
      {
        currentQuantity: extraFields.quantity || 0,
        quantity: extraFields.quantity || 0,
        discount: extraFields.discount || 0,
        id: 1,
        productId: 1,
        productData: {
          active: true,
          code: 'UNIX',
          id: 1,
          productId: 1,
          discountLimit: false,
          discountLimitedNumber: null,
          price: 0,
        },
      },
    ],
    key: Math.random() * 1000000,
    activeUpdatable: true,
  }
}
